/**
 * Main entry point - initializes the swimlane timeline
 */
import { SwimLaneTimeline } from './swimlane-timeline.js';

const container = document.getElementById('timelineContainer');
if (container) {
  new SwimLaneTimeline(container);
}
